import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

import { environment } from '../../../../environments/environment';
import { ImportSchema } from '../interfaces/import-schema.interface';

@Injectable({ providedIn: 'root' })
export class ImportSchemaService {
  private readonly url = `${environment.cafler_backoffice_back_url}/bulk-upload/schema`;

  private cached$: Observable<ImportSchema> | null = null;

  constructor(private readonly http: HttpClient) {}

  getSchema(): Observable<ImportSchema> {
    if (!this.cached$) {
      this.cached$ = this.http.get<ImportSchema>(this.url).pipe(shareReplay(1));
    }
    return this.cached$;
  }

  invalidateCache(): void {
    this.cached$ = null;
  }
}
